import { render, staticRenderFns } from "./_form.presentations.page.vue?vue&type=template&id=4c3bf370&scoped=true&"
import script from "./_form.presentations.page.vue?vue&type=script&lang=js&"
export * from "./_form.presentations.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.presentations.page.vue?vue&type=style&index=0&id=4c3bf370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3bf370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
